interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="w-full px-6 lg:px-12 py-4">
        <div className="flex items-center justify-between">
          {/* Left Links */}
          <div className="flex items-center gap-8">
            <a 
              href="#properties" 
              className={`text-sm font-light tracking-wide transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'
              }`}
            >
              物件情報
            </a>
            <a 
              href="#services" 
              className={`text-sm font-light tracking-wide transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'
              }`}
            >
              サービス
            </a>
            <a 
              href="#about" 
              className={`text-sm font-light tracking-wide transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'
              }`}
            >
              会社概要
            </a>
          </div>

          {/* Center Logo */}
          <div className="absolute left-1/2 transform -translate-x-1/2">
            <h1 className={`text-2xl font-serif tracking-widest transition-colors ${
              scrolled ? 'text-gray-900' : 'text-white'
            }`}>
              プレミアム不動産
            </h1>
          </div>

          {/* Right Buttons */}
          <div className="flex items-center gap-4">
            <button className={`flex items-center gap-2 transition-colors cursor-pointer whitespace-nowrap ${
              scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'
            }`}>
              <i className="ri-phone-line text-lg"></i>
              <span className="text-sm font-light">03-1234-5678</span>
            </button>
            <button className={`px-6 py-2 rounded-full font-medium text-sm transition-all cursor-pointer whitespace-nowrap ${
              scrolled 
                ? 'bg-gray-900 text-white hover:bg-gray-800' 
                : 'bg-white text-gray-900 hover:bg-gray-100'
            }`}>
              無料相談
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
